import { defineApi, defineModal, defineContainer } from './PluginCorePopover'

/**
 * @description Ensure that `_vfm` is used when function `installPlugin` is executed for the first time
 */
let _count = 0

// key để dùng
const _key = '$vfp'
// Tên component là popover
const _componentName = 'VueFinalPopover'
// Tên component chứa tất cả popover
const _dynamicContainerName = 'PopoversContainer'

/**
 * @description Support create multiple vfm instance
 */
export const defineVfp = () => {
  let api = defineApi()
  return {
    [_key]: api,
    [_componentName]: defineModal(api),
    [_dynamicContainerName]: defineContainer(api)
  }
}

/**
 * @description Create a vfm instance by default for directly support `import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal'`
 */
const _vfp = defineVfp()
export const { $vfp, VueFinalPopover, PopoversContainer } = _vfp

/**
 * @description Register vfm instance globally
 * @deprecated not available in vue-final-modal 4
 */
const installVfp = (App, options = {}) => {
  const { $vfp, VueFinalPopover, PopoversContainer } = _count === 0 ? _vfp : defineVfp()
  _count += 1
  const key = options.key || _key
  const componentName = options.componentName || _componentName
  const dynamicContainerName = options.dynamicContainerName || _dynamicContainerName
  Object.defineProperty(App.config.globalProperties, key, {
    get() {
      return $vfp
    }
  })
  App.provide(key, $vfp)
  App.component(componentName, VueFinalPopover)
  App.component(dynamicContainerName, PopoversContainer)
}

/**
 * @description Vue plugin for register vfm instance globally
 * @deprecated not available in vue-final-modal 4
 */
export const vfpPlugin = pluginOptions => ({
  install(App, options) {
    const _options = Object.assign({}, pluginOptions, options)
    installVfp(App, _options)
  }
})

vfpPlugin.install = installVfp
